import { render, staticRenderFns } from "./EditBrandModal.vue?vue&type=template&id=3f584202&scoped=true"
import script from "./EditBrandModal.vue?vue&type=script&lang=ts"
export * from "./EditBrandModal.vue?vue&type=script&lang=ts"
import style0 from "./EditBrandModal.vue?vue&type=style&index=0&id=3f584202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f584202",
  null
  
)

export default component.exports